/* eslint-disable tailwindcss/no-custom-classname */
import { useMemo } from "react";

import { ServiceMenuOptionTime } from "@/apis/clients";
import { Label } from "@/components/atoms/inputForms/Label";
import { CheckboxGroup } from "@/components/molecules/forms/CheckboxGroup";
import { ServiceOptionDescribe } from "@/components/organisms/service-form/ServiceOptionDescribe";
import { getCalendarTimeRequired } from "@/utils/common";
import { formatNumber } from "@/utils/number";
import { FieldValueChangeHandler, ServiceMenuDetail } from "@/states/service-form/types";

export interface ServiceOption {
  id: number;
  name: string;
  describe: string | undefined;
  price: number | undefined;
  minutes?: number | undefined;
  time?: ServiceMenuOptionTime;
  amount?: number;
  isShowTime?: number;
  isShowFree?: number;
}

interface CalendarOptionsAreaProps {
  options?: ServiceOption[];
  onFieldValueChange?: FieldValueChangeHandler;
  onChangeOptionIds?: (values: number[]) => void;
  isForm?: boolean;
  selectedOptionsIds?: number[];
  menu: ServiceMenuDetail
}
/**
 * オプションエリア
 */
export const CalendarOptionsArea = ({
  options,
  isForm = true,
  onChangeOptionIds,
  selectedOptionsIds,
  onFieldValueChange,
  menu
}: CalendarOptionsAreaProps) => {
  const optionItems = useMemo(() => {
    if (!options || options.length === 0) {
      return [];
    }
    return options.map((option) => {
      return {
        id: `option-${option.id}`,
        label: (
          <h5 className="font-bold break-word text-sm leading-[21px] ml-1">
            {option.name}
          </h5>
        ),
        value: option.id,
        option,
      };
    });
  }, [options]);

  if (optionItems.length === 0) return <></>;

  return (
    <div className="space-y-3">
      <Label className="text-gray-600">オプション</Label>
      <ul className="space-y-4">
        <CheckboxGroup
          items={optionItems}
          groupName="serviceMenuOptionIds"
          values={selectedOptionsIds || []}
          onChange={(values) => {
            onChangeOptionIds && onChangeOptionIds(values);
            onFieldValueChange && onFieldValueChange("serviceMenuId", menu.id);
          }}
          itemRenderer={(children, item) => (
            <li className="mt-3 rounded" key={item.option.id}>
              <div className="justify-between space-x-1 break-all">
                {isForm ? (
                  <div className="max-w-[100%] break-all">{children}</div>
                ) : (
                  <div className="font-bold max-w-[100%] break-all">
                    {item.option.name}
                  </div>
                )}
                <div className="pt-2 space-y-4 break-word mb-2">
                  {item.option.describe && (
                    <ServiceOptionDescribe
                      describe={item.option.describe}
                      classNames="pl-[25px]"
                    />
                  )}
                </div>

                <div className="my-auto min-w-[2.5rem] text-right font-bold text-sm">
                  {
                    item.option?.isShowTime ? 
                      <span className="font-normal mr-2">
                        {`${
                          getCalendarTimeRequired(Number(item?.option?.time)) || 0
                        }分`}
                      </span> : null
                  }
                  
                  {item.option?.amount && item.option?.amount > 0 ? (
                    `${formatNumber(item.option?.amount)}円（税込）`
                  ) : (
                    <>
                      {item.option?.isShowFree ? <span className="ml-2">無料</span> : null}
                    </>
                  )}
                </div>
              </div>
            </li>
          )}
        />
      </ul>
    </div>
  );
};
